import React, { useState, useRef, useEffect } from 'react';
import './AccountSelector.css';

function AccountSelector({ accounts, selectedAccountId, onSelect, onManageAccount, accountsLoading, accountsError }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const list = accounts || [];
  const selectedAccount = list.find((acc) => acc.id === selectedAccountId);

  const buttonLabel = accountsLoading
    ? 'Loading…'
    : selectedAccount?.name || (list.length === 0 ? 'No team' : 'Select team');
  const buttonTitle = list.length === 0 && accountsError ? accountsError : undefined;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleSelect = (accountId) => {
    onSelect(accountId);
    setIsOpen(false);
  };

  const handleManageAccount = () => {
    setIsOpen(false);
    if (onManageAccount) onManageAccount();
  };

  return (
    <div className="account-selector-wrapper" ref={dropdownRef}>
      <button
        type="button"
        className="account-selector-button"
        title={buttonTitle}
        onClick={() => !accountsLoading && setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select team"
        disabled={!!accountsLoading}
      >
        <span className="account-selector-label">
          {buttonLabel}
        </span>
        <span className={`account-selector-chevron ${isOpen ? 'open' : ''}`} aria-hidden>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      {isOpen && (
        <div className="account-selector-dropdown" role="listbox">
          {list.length === 0 && !accountsLoading && accountsError && (
            <div className="account-selector-error" role="alert">
              {accountsError}
            </div>
          )}
          {list.length > 0 && !accountsLoading && (
            <>
              <div className="account-selector-list">
                {list.map((account) => (
                  <button
                    key={account.id}
                    type="button"
                    role="option"
                    aria-selected={account.id === selectedAccountId}
                    className={`account-selector-item ${account.id === selectedAccountId ? 'selected' : ''}`}
                    onClick={() => handleSelect(account.id)}
                  >
                    <span className="account-selector-item-name">{account.name || account.id}</span>
                    {account.id === selectedAccountId && (
                      <span className="account-selector-check" aria-hidden>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </span>
                    )}
                  </button>
                ))}
              </div>
              <div className="account-selector-divider" />
            </>
          )}
          <button
            type="button"
            className="account-selector-manage"
            onClick={handleManageAccount}
          >
            <span>Manage account</span>
            <span className="account-selector-manage-chevron" aria-hidden>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </span>
          </button>
        </div>
      )}
    </div>
  );
}

export default AccountSelector;
